export { useNonF2fMedicalCategories } from './hooks';
export { MedicalCategoryModel, EMedicalCategoryCategory, type MedicalCategory } from './model/MedicalCategory';
